import { bannerFragment, seoFragment } from './fragments.gql'

export default slug => `query {
  sidebarPage(filter: {slug: {eq: "${slug.replace('/', '__')}"}}) {
    title
    titleTag
    structuredTextBody {
      value
      blocks {
        ... on DialogComponentRecord {
          __typename
          _modelApiKey
          id
          componentName
        }
      }
    }
    updatedAt
    slug
    banner {
      ${bannerFragment}
    }
    ${seoFragment}
  }
}`
